import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SelectLanguagesService } from '../../services/select-languages.service';

@Component({
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.scss']
})
export class SelectLanguageComponent implements OnInit, OnDestroy {

  public currentSetSelectedLanguage: string = '';
  public notifier = new Subject();

  constructor(
    private translate: TranslateService,
    private _selectLanguagesService: SelectLanguagesService,
    private _activatedRoute: ActivatedRoute) { }
  
  ngOnInit(): void {
    this._activatedRoute.params.subscribe(params => {
      this._selectLanguagesService.getSelectedLanguageObs().pipe(takeUntil(this.notifier)).subscribe(language => {
        if(params['requestLocale']) {
          if(!localStorage.getItem('languageFromURL'))
            localStorage.setItem('languageFromURL', params['requestLocale'])
          let languageFromURL = localStorage.getItem('languageFromURL');
          this.translate.use(languageFromURL);
          this.currentSetSelectedLanguage = languageFromURL;
        } else {
          this.translate.use(language);
          this.currentSetSelectedLanguage = language;
        }
      });
    })
    
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

}
